var _a;
import { GatewayConfiguration, } from '@contentsquare/uxanalytics-client';
import { Notifications } from '../constants/notifications';
const FIELD_KEY = '__hls#gw-config';
const isNode = typeof window === 'undefined';
const wnd = isNode ? global : window;
wnd[FIELD_KEY] = (_a = wnd[FIELD_KEY]) !== null && _a !== void 0 ? _a : {};
export class ClientFactory {
    static get fields() {
        return wnd[FIELD_KEY];
    }
    static instanciate(client) {
        const instance = new client(this.fields.config);
        const notifyingProxy = isNode ? new client(this.fields.config) : ClientFactory.createClientProxy(client, instance);
        ClientFactory.clients.set(client, notifyingProxy);
        return notifyingProxy;
    }
    static init(config, jwt) {
        this.fields.config = typeof config === 'string' ? new GatewayConfiguration(config, jwt) : config;
    }
    static get(client) {
        return ClientFactory.clients.has(client)
            ? ClientFactory.clients.get(client)
            : ClientFactory.instanciate(client);
    }
    static createClientProxy(ctr, instance) {
        return new Proxy(instance, {
            get(target, prop, receiver) {
                var _a;
                const origin = Reflect.get(target, prop, receiver);
                const supportsCache = typeof origin === 'function' && ((_a = instance === null || instance === void 0 ? void 0 : instance.__shouldResetCache) === null || _a === void 0 ? void 0 : _a.has(prop));
                if (!supportsCache) {
                    return origin;
                }
                const notificationEvent = new CustomEvent(Notifications.Crud, {
                    detail: ctr,
                });
                return function (...args) {
                    const result = origin.apply(this, args);
                    if (result instanceof Promise) {
                        return result.then((r) => {
                            window.dispatchEvent(notificationEvent);
                            return r;
                        });
                    }
                    else {
                        window.dispatchEvent(notificationEvent);
                        return result;
                    }
                };
            },
        });
    }
}
ClientFactory.clients = new Map();
//# sourceMappingURL=app.client.factory.js.map